import { apiAxios as authAxios } from '../axios.config';

export const listCompanyTypologies = () => {
    return authAxios.get('/api/companyTypology');
}
